/* eslint global-require: 0 */
module.exports = require('./Utils');


//////////////////
// WEBPACK FOOTER
// ./~/enzyme-adapter-utils/build/index.js
// module id = 1181
// module chunks = 168707334958949